import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'
import type { ConnectionState } from '@hermes/shared'

export type TabId = 'home' | 'chat' | 'clock' | 'calendar' | 'content' | 'education' | 'browser'

interface Store {
  tab: TabId
  setTab: (tab: TabId) => void
  state: ConnectionState
  setState: (state: ConnectionState) => void
  model: string | null
}

const Ctx = createContext<Store | null>(null)

export function OrbitProvider({ children }: { children: ReactNode }) {
  const [tab, setTab] = useState<TabId>('calendar')
  const [state, setState] = useState<ConnectionState>('connecting')
  const value = useMemo<Store>(
    () => ({ tab, setTab, state, setState, model: 'защищённый режим' }),
    [tab, state]
  )
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useOrbit(): Store {
  const value = useContext(Ctx)
  if (!value) throw new Error('useOrbit must be used within OrbitProvider')
  return value
}
